(function ($) {
    "use strict";
    $(function () {

        $('.js-service-toggle').on('click', function (e) {
            e.preventDefault();
            $('.js-service-toggle.active').removeClass('active');
            $(this).addClass('active');

            const selectedTab = $(this).data('tab');
            $('.js-service-tab.show').removeClass('show');
            $('.js-service-tab').each(function (i, item) {
                const id = $(item).attr('id');
                if (id === selectedTab) {
                    $(item).addClass('show');
                }
            });
        });



        $(document).on("click", ".js-service-button", function (e) {
            e.preventDefault();
            var index = $(".js-service-form .slick-current.slick-active").index();

            if (!$(".js-service-form").parsley().validate(`block-${index}`)) {
                return;
            }

            $(".js-service-form").slick("slickNext");
            $(".js-status-wrapper").addClass("active");
            $('.js-offer-select-group').removeClass('d-none')

        });


        $(document).on("click", ".js-service-prev-button", function (e) {
            e.preventDefault();
            $(".js-service-form").slick("slickPrev");
            $(".js-status-wrapper").removeClass("active");
            $('.js-offer-select-group').addClass('d-none')
        });



    });
})(jQuery);
